import { __decorate } from "tslib";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map } from "rxjs";
import { ApiPropertyValuationValuation } from "../../../../../shared/constants/api-constants/api-property-valuation-valuation.constant";
let ViewBlockPropertiesPvService = class ViewBlockPropertiesPvService {
    http;
    constructor(http) {
        this.http = http;
    }
    get(propertyId) {
        const params = {
            $filter: `propertyId eq ${propertyId}`,
            $expand: "multiValues"
        };
        return this.http.get(ApiPropertyValuationValuation.URL, { params }).pipe(map(response => {
            return response.value;
        }));
    }
    static ctorParameters = () => [
        { type: HttpClient }
    ];
};
ViewBlockPropertiesPvService = __decorate([
    Injectable({
        providedIn: "root"
    })
], ViewBlockPropertiesPvService);
export { ViewBlockPropertiesPvService };
